import { NEXT_PUBLIC_TENANT_ID } from '@/configs/env'
import axiosService from '@/lib/axios'
import { ProductResponse } from '@/types/product'

export function getProductDetail(customId: string) {
  return axiosService.get<ProductResponse>(`/v1/TenantProduct/${NEXT_PUBLIC_TENANT_ID}/${customId}`)
}
